import { Action, NavigationTypeState, unreadMessageState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { getTheme } from 'shared/util/utility';

const initialUnreadMessageState: unreadMessageState = {
	lastMessageTitle: '',
	messageCount: 0,
	lastMessageDate: '',
	lastMessageId: 0,
};
const navigationInitialState: NavigationTypeState = {
	appTheme: getTheme(),
	breadcrumbs: [],
	unreadMessages: initialUnreadMessageState,
	isEventPopup: false,
	onClickArrow: () => null,
};

const navigationReducer = (state: NavigationTypeState = navigationInitialState, action: Action): NavigationTypeState => {
	switch (action.type) {
		case actionTypes.APP_THEME:
			return { ...state, appTheme: action.payload };
		case actionTypes.UPDATE_BREADCRUMBS:
			return { ...state, breadcrumbs: action.payload };
		case actionTypes.UNREAD_MESSAGE_SUCCESS:
			return { ...state, unreadMessages: action.payload.unreadMessages };
		case actionTypes.SET_ARROW_STATE:
			return {
				...state,
				isEventPopup: action.payload.isArrow,
				onClickArrow: action.payload.onClickArrow,
			};
		default:
			return state;
	}
};

export { navigationReducer };
